<template>
    <div class="calc-field" :class="{ 'calc-field--full': full }">
        <label v-if="label || $slots.info" class="calc-field__label">
            <span v-if="label">{{ translatedLabel }}</span>
            <slot name="info" />
        </label>
        <slot />
    </div>
</template>

<script>
export default {
    name: 'CalcField',

    props: {
        label: {
            type: String,
            default: '',
        },
        full: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        translatedLabel() {
            if (!this.label) return ''
            if (this.label.startsWith('§')) return this.$t(this.label)
            return this.label
        },
    },
}
</script>

<style scoped>
.calc-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.calc-field--full {
    grid-column: 1 / -1;
}

.calc-field__label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-family: 'TWK Lausanne', 'Inter', sans-serif;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: var(--calc-ink-50);
    font-weight: 400;
}
</style>
